function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
export var RemuxedBuffer = /*#__PURE__*/_createClass(function RemuxedBuffer() {
  _classCallCheck(this, RemuxedBuffer);
  /** @type{string} */
  this.mimetype = '';
  /** @type{Uint8Array|null} */
  this.init = null;
  /** @type{Uint8Array[]} */
  this.data = [];
  /** @type{number} */
  this.bufferDuration = 0;
});
var RemuxedBufferManager = /*#__PURE__*/function () {
  function RemuxedBufferManager() {
    _classCallCheck(this, RemuxedBufferManager);
    /** @type{Object.<string, RemuxedBuffer>} */
    this.sources = {};
  }

  /**
   *
   * @param {string} name
   * @return {RemuxedBuffer}
   */
  _createClass(RemuxedBufferManager, [{
    key: "getSource",
    value: function getSource(name) {
      return this.sources[name];
    }

    /**
     * @param {string} name
     * @return {RemuxedBuffer}
     */
  }, {
    key: "createSource",
    value: function createSource(name) {
      this.sources[name] = new RemuxedBuffer();
      return this.sources[name];
    }
  }, {
    key: "clear",
    value: function clear() {
      this.sources = {};
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.clear();
    }
  }]);
  return RemuxedBufferManager;
}();
export default RemuxedBufferManager;